import EdgeCommon from "../edgeCommon";

export default class EdgeProfile extends EdgeCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'edge_profile';
    this.partName = 'Edge Profile';
    this.translateId = "visualizer.kitchen.countertop.edge_profile";
    // this.isStoneFeature = true;
    this.customClassName = "edge";
    this.hasNoVisualizerLayers = true;
  }
}
